// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bd19edf8","239":"058734cd","553":"ee3d8476"}[chunkId] + ".chunk.js";
};